import {createSlice, PayloadAction} from '@reduxjs/toolkit';

type DataViewMode = 'table' | 'tile' | null;

export type PageViewState = {
  welcomeMultiClient: DataViewMode;
  welcomeMultiClientTab: number;
  manageClients: DataViewMode;
  manageTeamMembers: 'all' | 'invited' | 'active' | 'inactive';
};

const initialState: PageViewState = {
  welcomeMultiClient: null,
  welcomeMultiClientTab: 0,
  manageClients: null,
  manageTeamMembers: 'all',
};

const pageViewStateSlice = createSlice({
  name: 'pageViewStateSlice',
  initialState: initialState,
  reducers: {
    setWelcomeMultiClientPageState: (
      state,
      action: PayloadAction<DataViewMode>
    ) => {
      state.welcomeMultiClient = action.payload;
    },
    setWelcomeMultiClientTabState: (state, action: PayloadAction<number>) => {
      state.welcomeMultiClientTab = action.payload;
    },
    setManageClientsPageState: (state, action: PayloadAction<DataViewMode>) => {
      state.manageClients = action.payload;
    },
    setmanageTeamMembersPageState: (
      state,
      action: PayloadAction<'all' | 'invited' | 'active' | 'inactive'>
    ) => {
      state.manageTeamMembers = action.payload;
    },
    resetPageState: () => {
      return initialState;
    },
  },
});

export const {
  setWelcomeMultiClientPageState,
  setWelcomeMultiClientTabState,
  setManageClientsPageState,
  setmanageTeamMembersPageState,
  resetPageState,
} = pageViewStateSlice.actions;
export default pageViewStateSlice.reducer;
